( function( $ ) {
	'use strict';

	$( function() {
		const $trigger = $( '.js-offcanvas-submenu-trigger' );
		const $link = $( '.js-offcanvas-submenu-link' );
		const bodyClass = '.js-offcanvas-submenu-body';
		const activeClassName = 'is-active';

		$trigger.on( 'click', function( event ) {
			let $body = $( this ).siblings( bodyClass );
			console.log( 'clicked', $body );

			if ( $body.length ) {
				event.preventDefault();
				$( this ).toggleClass( activeClassName );
				$body.slideToggle();
			}
		} );
	} );
} )( jQuery );
